














































import { Component, Prop, Vue } from 'vue-property-decorator';
import { hideModal } from '@/helpers/modal';

@Component({
    name: 'MoreInfoModal',
})
export default class MoreInfoModal extends Vue {
    @Prop({
        required: true,
    })
    public insight: string;

    @Prop({
        required: true,
    })
    public content: string;

    @Prop({
        required: true,
    })
    public id: number;

    public hideModal = hideModal;

    public isFullscreen = false;

    private mounted() {
        const shadow = (this as any).$refs.printdiv.attachShadow({ mode: 'open' });
        const div = document.createElement('div');
        div.innerHTML = this.content;

        const style = document.createElement('style');
        style.innerHTML = `
          * {
              font-family: 'Avenir', Helvetica, Arial, sans-serif !important;
              -webkit-font-smoothing: antialiased !important;
              -moz-osx-font-smoothing: grayscale !important;
          }
        `;
        shadow.appendChild(style);
        shadow.appendChild(div);
    }
}
